export enum ETableFilterType {
  CHECKBOX = 'checkbox',
  TEXT = 'text',
}
